import { Moment } from './moment';
import { oneDayInUnix } from './dateParser';

// for now our backend set expire_months: 1200 for never expired plans.
const neverExpiredPeriod = 1200 * 30 * oneDayInUnix;
export const isNeverExpired = (createdAt, expiredAt) =>
  new Moment(expiredAt).getTime() - new Moment(createdAt).getTime() >=
  neverExpiredPeriod;



// WEBPACK FOOTER //
// ./app/utils/checkPlanExpire.js